import { render, staticRenderFns } from "./MCPIcon.vue?vue&type=template&id=9b103856&scoped=true"
import script from "./MCPIcon.vue?vue&type=script&lang=js"
export * from "./MCPIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b103856",
  null
  
)

export default component.exports